import React, { useState } from 'react'
import Button from 'components/UI/Button'

import 'components/UI/YesNo/yes-no.pcss'

const YesNo = ({
    renderStartButton,
    startText,
    startTrackName,
    yesText,
    onYes,
    yesTrackName,
    onActiveChange,
    noText,
    noTrackName,
    startButtonProps = {},
}) => {
    const [active, setActive] = useState(false)

    const setActiveState = (active) => {
        setActive(active)
        onActiveChange && onActiveChange(active)
    }

    const renderStart = () => {
        return renderStartButton ? (
            renderStartButton({
                onClick: () => setActiveState(true)
            })
        ) : (
            <Button
                className="button button--s-on-mobile button--tertiary yes-no__start"
                type="button"
                onClick={() => setActiveState(true)}
                trackName={startTrackName}
                {...startButtonProps}
            >
                {startText}
            </Button>
        )
    }

    return (
        <span className="yes-no">
            {active ? (
                <>
                    <Button
                        key="yes"
                        className="button button--s-on-mobile button--tertiary-delete yes-no__yes"
                        type="button"
                        onClick={onYes}
                        trackName={yesTrackName}
                    >
                        {yesText}
                    </Button>
                    <span className="divider">/</span>
                    <Button
                        key="no"
                        className="button button--s-on-mobile button--tertiary yes-no__no"
                        type="button"
                        onClick={() => setActiveState(false)}
                        trackName={noTrackName}
                    >
                        {noText}
                    </Button>
                </>
            ) : renderStart()}
        </span>
    )
}

export default YesNo
